function customerRecommendData() {
  return {
    practitionerID: null,
    patients: [],
    filteredPatientsData: [],
    searchQuery: '',
    previousSearchQuery: '',
    filterStatus: 'all',
    sortBy: 'title',
    sortOrder: 'asc',
    currentPage: 1,
    itemsPerPage: 1,
    showPatientForm: false,
    showPatientFormSuccess: false,
    successTimeoutId: null,
    termsPatientForm: false,
    pagesToShow: 5,
    isAwaitingResponse: false,
    deleteScriptIDinDJ:'',
    notification: {
      message: '',
      status: 'ok',
    },
    isUrlSuccessParam: false,

    normalizeDate(dateString) {
      const isFormattedDate = /^\d{2}\/\d{2}\/\d{4}$/.test(dateString);
      if (isFormattedDate) {
        return dateString;
      }
      return this.formatDate(dateString);
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    removeURLParam(param) {
      const url = new URL(window.location);
      const urlParams = new URLSearchParams(url.search);

      if (urlParams.has(param)) {
        urlParams.delete(param);
        window.history.replaceState(
          {},
          document.title,
          `${url.pathname}?${urlParams}`
        );

        this.isUrlSuccessParam = false;
      }
    },

    isURLParamsSuccess() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('patient_success')) {
        this.showPatientForm = true;
        this.showPatientFormSuccess = true;
        this.isUrlSuccessParam = true;

        this.successTimeoutId = setTimeout(() => {
          if (this.successTimeoutId) {
            this.showPatientForm = false;
            this.showPatientFormSuccess = false;

            this.getNewUser();

            this.removeURLParam('patient_success');

            this.successTimeoutId = null;
          }
        }, 10000);
      }
    },

    init(practitionerID, itemsPerPage,  deleteScriptIDinDJ, copyScriptIDinDJ) {
      this.practitionerID = `gid://shopify/Customer/${practitionerID}`;
      this.itemsPerPage = itemsPerPage ? itemsPerPage : 6;
      this.deleteScriptIDinDJ = deleteScriptIDinDJ;

      const patientsScript = document.getElementById('RECOMMENDATIONS_DATA');
      if (patientsScript) {
        this.patients = JSON.parse(patientsScript.textContent).map(p => ({
          ...p,
          raw_date: p.created || p.register_date || '', 
          created: p.created ? this.normalizeDate(p.created) : '',
          updated: p.updated ? this.normalizeDate(p.updated) : '',
          name: p.patient_name || p.name || ''
        }));
      }

      this.isURLParamsSuccess();
    },

    formatSortBy() {
      if (this.sortBy === 'title') return 'Title';
      if (this.sortBy === 'name') {
        return 'Name';
      } else if (this.sortBy === 'created') {
        return 'Created';
      }
      return 'Unknown';
    },

    formatSortOrder() {
      if (this.sortOrder === 'asc') {
        return this.sortBy === 'name' ? 'A-Z' : 'ASC';
      } else if (this.sortOrder === 'desc') {
        return this.sortBy === 'name' ? 'Z-A' : '';
      }
      return 'Unknown';
    },

    get totalPages() {
      return Math.ceil(this.filteredPatientsData.length / this.itemsPerPage);
    },
    get filteredPatients() {
      let query = this.searchQuery?.toLowerCase().trim();
      
      let filtered = this.patients.filter((p) => {
        const matchesStatus = this.filterStatus === 'all' || p.status?.toLowerCase() === this.filterStatus.toLowerCase();
        const matchesQuery = !query || 
                             p.patient_name?.toLowerCase().includes(query) || 
                             p.name?.toLowerCase().includes(query) || 
                             p.email?.toLowerCase().includes(query);
        return matchesStatus && matchesQuery;
      });

      filtered.sort((a, b) => {
        const field = this.sortBy;

        // SORT DATE
        if (field === 'created' || field === 'updated' || field === 'register_date') {
          const timeA = new Date(a.raw_date || a[field] || 0).getTime();
          const timeB = new Date(b.raw_date || b[field] || 0).getTime();
          return this.sortOrder === 'asc' ? timeA - timeB : timeB - timeA;
        }

        // SORT TITLE
        if (field === 'title') {
          const valA = (a.title || '').toLowerCase();
          const valB = (b.title || '').toLowerCase();
          return this.sortOrder === 'asc'
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        }

        // SORT NAME (fallback)
        const valA = (a.name || a.patient_name || '').toLowerCase();
        const valB = (b.name || b.patient_name || '').toLowerCase();

        return this.sortOrder === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      });

      this.filteredPatientsData = filtered;
      return filtered;
    },

    get paginatedPatients() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredPatients.slice(start, start + this.itemsPerPage);
    },

    get visiblePages() {
      const half = Math.floor(this.pagesToShow / 2);
      let start = this.currentPage - half;
      let end = this.currentPage + half;

      if (start < 1) {
        start = 1;
        end = Math.min(this.pagesToShow, this.totalPages);
      }

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(1, this.totalPages - this.pagesToShow + 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    sort(field, order = null) {
      if (order) {
        this.sortOrder = order;
      } else {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      }

      this.sortBy = field;
    },

    clearSuccessTimeout() {
      if (this.successTimeoutId) {
        clearTimeout(this.successTimeoutId);
        this.successTimeoutId = null;
      }
    },

    closePatientForm() {
      this.getNewUser();

      this.clearSuccessTimeout();

      if (this.showPatientForm) {
        this.showPatientForm = false;
      }

      if (this.showPatientFormSuccess) {
        this.showPatientFormSuccess = false;
      }
    },

    openPatientForm() {
      this.clearSuccessTimeout();

      this.showPatientForm = true;
    },

    showNotification(notification, timeout = 5000) {
      this.notification = { ...notification };

      setTimeout(() => {
        this.clearNotification();
      }, timeout);
    },

    clearNotification() {
      this.notification = {
        message: '',
        status: 'ok',
      };
    },

    flattenMetaobject(node) {
      const fieldData = {};
      if (node.fields) {
        node.fields.forEach(f => {
          fieldData[f.key] = f.value;
        });
      }
      const handle = node.handle;
      return {
        system_id: node.id,
        title: fieldData.title || 'Untitled',
        patient_name: fieldData.patient_name || '',
        raw_date: fieldData.created || fieldData.register_date || '',
        updated: fieldData.updated ? this.normalizeDate(fieldData.updated) : '',
        status: fieldData.status || '',
        created: fieldData.created ? this.normalizeDate(fieldData.created) : '',
        note: fieldData.note || '',
        products: typeof fieldData.products === 'string' ? JSON.parse(fieldData.products) : (fieldData.products || []),
        created_by: fieldData.created_by || '',
        recommend_url: handle
          ? `/pages/share-recommendation/${handle}`
          : null
      };
    },

    async removeCustomerRecommendations(systemID) {
      this.isAwaitingResponse = true;

      const taskId = this.deleteScriptIDinDJ;
      const url = `/apps/datajet/task/${taskId}`;
      

      const cleanID = String(systemID).split('/').pop();

      const requestData = {
        store: true,
        recommendation_id: `gid://shopify/Metaobject/${cleanID}`,
      };

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData),
        });

        const res_data = await response.json();
        this.isAwaitingResponse = false;
        if (res_data.status === 'success' || res_data.status === 'updated' || res_data.status === 'ok') {
          this.showNotification({ message: res_data.message, status: 'ok' });
          this.patients = this.patients.filter(
            item => item.system_id !== systemID
          );

          if (this.patients.length === 0) {
            this.currentPage = 1;
          } else {
            const totalPages = Math.ceil(this.patients.length / this.itemsPerPage);
            if (this.currentPage > totalPages) {
              this.currentPage = totalPages;
            }
          }

          if (res_data.data) {
            const rawResponse = typeof res_data.data === 'string' ? JSON.parse(res_data.data) : res_data.data;

            if (rawResponse.references && rawResponse.references.nodes) {
              const newItems = rawResponse.references.nodes.map(node => this.flattenMetaobject(node));

              this.patients = newItems;
              
              const totalPages = Math.ceil(this.patients.length / this.itemsPerPage);

              if (this.currentPage > totalPages) {
                this.currentPage = totalPages > 0 ? totalPages : 1;
              }
            }
          }
        }
      } catch (error) {
        this.isAwaitingResponse = false;
        console.error('Error:', error);
      }
    },

    getInviteDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const hours = String(currentDate.getHours()).padStart(2, '0');
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');

      const timezoneOffset = currentDate.getTimezoneOffset();
      const timezoneHours = String(
        Math.floor(Math.abs(timezoneOffset) / 60)
      ).padStart(2, '0');
      const timezoneMinutes = String(Math.abs(timezoneOffset) % 60).padStart(
        2,
        '0'
      );
      const timezoneSign = timezoneOffset > 0 ? '-' : '+';

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezoneSign}${timezoneHours}:${timezoneMinutes}`;
    },
  };
}
